import { useState, useEffect, useRef, useCallback } from 'react'
import classnames from 'classnames/bind'
import { Swiper, SwiperSlide } from 'swiper/react'
import Marquee from 'react-fast-marquee'

// Components
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface TickerTapeProps {
  tickerTape: string[]
}

const MAX_MARQUEE_WIDTH = 170

const MIN_MARQUEE_SECOND = 5

const TickerTape = (props: TickerTapeProps) => {
  const { tickerTape } = props

  const [currentIndex, setCurrentIndex] = useState(0)
  const [canShowNext, setCanShowNext] = useState(false) // 如果是跑馬燈，也要至少過五秒才換下一個

  const swiperRef = useRef<any>(null)

  const currentMarqueeElement: any = document.getElementById(`marquee-${currentIndex}`)

  const currentMarqueeElementWidth = currentMarqueeElement?.offsetWidth

  useEffect(() => {
    let timer: any = null

    timer = setTimeout(() => {
      setCanShowNext(true)
    }, MIN_MARQUEE_SECOND * 1000)

    return () => {
      clearTimeout(timer)
    }
  }, [currentIndex])

  useEffect(() => {
    let timer: any = null

    if (currentMarqueeElementWidth < MAX_MARQUEE_WIDTH) {
      timer = setTimeout(() => {
        handleIndexSet()
        swiperRef.current.slideNext()
      }, MIN_MARQUEE_SECOND * 1000)
    }

    return () => {
      clearTimeout(timer)
    }
  }, [currentMarqueeElementWidth, currentIndex])

  const handleIndexSet = useCallback(() => {
    if (currentIndex < tickerTape.length - 1) {
      setCurrentIndex(currentIndex + 1)
    } else {
      setCurrentIndex(0)
    }

    setCanShowNext(false)
  }, [currentIndex])

  const handleCycleComplete = () => {
    if (canShowNext) {
      swiperRef.current.slideNext()
      handleIndexSet()
    }
  }

  return (
    <div className={cx('tickerTape')}>
      <div className={cx('tickerTape-icon')}>
        <Icon.Speaker />
      </div>

      <div className={cx('tickerTape__content')}>
        {tickerTape.length > 0 && (
          <Swiper className={cx('tickerTape__carousell')} onInit={(ref) => (swiperRef.current = ref)} direction={'vertical'} loop>
            {tickerTape.map((item, index) => (
              <SwiperSlide key={`${item}-${index}`}>
                <Marquee
                  speed={40}
                  play={currentMarqueeElementWidth > MAX_MARQUEE_WIDTH && index === currentIndex}
                  onCycleComplete={handleCycleComplete}
                  delay={1.5}
                >
                  <div id={`marquee-${index}`} className={cx('tickerTape-text')}>
                    {item}
                  </div>
                </Marquee>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  )
}

export default TickerTape
